import { createRouter, createWebHistory } from 'vue-router';
import BodyView from '@/layout/BodyView.vue';
import indexDashbord from '@/pages/indexDashbord.vue';
import PerfilUsuario from '@/pages/PerfilUsuario.vue';
import MisDispositivos from '@/pages/MisDispositivos.vue';
import UsuariosEliminados from '@/pages/UsuariosEliminados.vue';
import CambiarContrasena from '@/pages/CambiarContrasena.vue';
import UploadImages from '@/pages/UploadImages.vue';
import ImageBank from '@/pages/ImageBank.vue';
import ProductosApp from '@/pages/ProductosApp.vue';
import CargaIndividualGS1 from '@/pages/CargaIndividualGS1.vue';
import CargaMultipleGS1 from '@/pages/CargaMultipleGS1.vue';
import AltaUsuarios from '@/pages/AltaUsuarios.vue';
import ConsultarUsuarios from '@/pages/ConsultarUsuarios.vue';
import Configuracion from '@/pages/Configuracion.vue';
import Roles from '@/pages/Roles.vue';
import ConfiguracionBusquedaExcel from '@/pages/ConfiguracionBusquedaExcel.vue';
import authView from '@/auth/authView.vue';
import loginPage from '@/auth/loginPage.vue';
import restablecerContrasena from '@/auth/restablecerContrasena.vue';
import recuperarContrasena from '@/auth/recuperarContrasena.vue';
import { getToken } from '@/services/api';
import store from '@/store';
import { tieneAcceso, primeraRutaPermitida } from '@/utils/permisos';

// meta.permiso: ruta de la opción de menu.json que el rol debe tener asignada para entrar.
const routes = [
  {
    path: '',
    redirect: '/dashboard',
  },
  {
    path: '/auth',
    component: authView,
    children: [
      {
        path: 'login',
        name: 'login',
        component: loginPage,
        meta: {
          title: 'Login | Procesador de Imágenes',
          public: true,
        },
      },
      {
        path: 'recuperar-contrasena',
        name: 'recuperar-contrasena',
        component: recuperarContrasena,
        meta: {
          title: 'Recuperar Contraseña | Procesador de Imágenes',
          public: true,
        },
      },
      {
        path: 'restablecer-contrasena',
        name: 'restablecer-contrasena',
        component: restablecerContrasena,
        meta: {
          title: 'Restablecer Contraseña | Procesador de Imágenes',
          public: true,
        },
      },
    ],
  },
  {
    path: '/dashboard',
    component: BodyView,
    children: [
      {
        path: '',
        name: 'dashboard',
        component: indexDashbord,
        meta: {
          title: 'Dashboard | Procesador de Imágenes',
          permiso: '/dashboard',
        },
      },
      {
        // Query "foto": TODAS (por defecto), SI o NO.
        path: 'productos-app',
        name: 'productos-app',
        component: ProductosApp,
        meta: {
          title: 'Reporte de Productos APP | Procesador de Imágenes',
          permiso: '/dashboard',
        },
      },
      {
        path: 'mi-perfil',
        name: 'mi-perfil',
        component: PerfilUsuario,
        meta: {
          title: 'Mi Perfil | Procesador de Imágenes',
        },
      },
      {
        path: 'mi-perfil/dispositivos',
        name: 'mis-dispositivos',
        component: MisDispositivos,
        meta: {
          title: 'Administra tus dispositivos | Procesador de Imágenes',
        },
      },
      {
        path: 'cargar-imagenes',
        name: 'upload-images',
        component: UploadImages,
        meta: {
          title: 'Subir Imágenes | Procesador de Imágenes',
          permiso: '/dashboard/cargar-imagenes',
        },
      },
      {
        path: 'banco-imagenes',
        name: 'image-bank',
        component: ImageBank,
        meta: {
          title: 'Banco de Imágenes | Procesador de Imágenes',
          permiso: '/dashboard/banco-imagenes',
        },
      },
      {
        // Ruta anterior (página con pestañas): se conserva para enlaces guardados.
        path: 'cargar-productos-gs1',
        redirect: '/dashboard/cargar-productos-gs1/individual',
      },
      {
        path: 'cargar-productos-gs1/individual',
        name: 'carga-individual-gs1',
        component: CargaIndividualGS1,
        meta: {
          title: 'Carga Individual GS1 | Procesador de Imágenes',
          permiso: '/dashboard/cargar-productos-gs1/individual',
        },
      },
      {
        path: 'cargar-productos-gs1/excel',
        name: 'carga-multiple-gs1',
        component: CargaMultipleGS1,
        meta: {
          title: 'Carga Múltiple GS1 | Procesador de Imágenes',
          permiso: '/dashboard/cargar-productos-gs1/excel',
        },
      },
      {
        path: 'alta-usuarios',
        name: 'alta-usuarios',
        component: AltaUsuarios,
        meta: {
          title: 'Alta de Usuarios | Procesador de Imágenes',
          permiso: '/dashboard/alta-usuarios',
        },
      },
      {
        path: 'consultar-usuarios',
        name: 'consultar-usuarios',
        component: ConsultarUsuarios,
        meta: {
          title: 'Consultar Usuarios | Procesador de Imágenes',
          permiso: '/dashboard/consultar-usuarios',
        },
      },
      {
        path: 'usuarios-eliminados',
        name: 'usuarios-eliminados',
        component: UsuariosEliminados,
        meta: {
          title: 'Usuarios Eliminados | Procesador de Imágenes',
          permiso: '/dashboard/usuarios-eliminados',
        },
      },
      {
        path: 'configuracion',
        name: 'configuracion',
        component: Configuracion,
        props: { tipo: 'carga' },
        meta: {
          title: 'Destinatarios Carga de Imágenes | Procesador de Imágenes',
          permiso: '/dashboard/configuracion',
        },
      },
      {
        path: 'configuracion/gs1',
        name: 'configuracion-gs1',
        component: Configuracion,
        props: { tipo: 'gs1' },
        meta: {
          title: 'Destinatarios Reporte GS1 | Procesador de Imágenes',
          permiso: '/dashboard/configuracion/gs1',
        },
      },
      {
        path: 'configuracion/busqueda-excel',
        name: 'configuracion-busqueda-excel',
        component: ConfiguracionBusquedaExcel,
        meta: {
          title: 'Búsqueda Excel | Procesador de Imágenes',
          permiso: '/dashboard/configuracion/busqueda-excel',
        },
      },
      {
        path: 'roles',
        name: 'roles',
        component: Roles,
        meta: {
          title: 'Roles | Procesador de Imágenes',
          permiso: '/dashboard/roles',
        },
      },
      {
        path: 'cambiar-contraseña',
        name: 'cambiar-contrasena',
        component: CambiarContrasena,
        meta: {
          title: 'Cambiar Contraseña | Procesador de Imágenes',
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (typeof to.meta.title === 'string') {
    document.title = to.meta.title;
  }

  const isPublic = to.meta.public;
  const hasUser = !!getToken();

  if (!isPublic && !hasUser) {
    return next('/auth/login');
  }
  // Si viene logueado e intenta ir al login, lo mando al dashboard
  if (hasUser && to.name === 'login') {
    return next('/dashboard');
  }

  if (to.meta.permiso) {
    let usuario = store.state.autenticacion.usuarioActual;
    if (!usuario) {
      usuario = await store.dispatch('autenticacion/cargarUsuarioActual');
    }
    // Sin usuario (p. ej. backend caído) no se puede validar; el backend sigue protegiendo los datos.
    if (usuario && !tieneAcceso(usuario, to.meta.permiso)) {
      return next(primeraRutaPermitida(usuario));
    }
  }

  next();
});

export default router;
